// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const singleMaintainerProjectsCubeQuery = gql`
  query ($organizationUrl: String!, $memberId: String!, $dateRange: String!) {
    singleMaintainerProjects(
      organizationUrl: $organizationUrl
      memberId: $memberId
      dateRange: $dateRange
    ) {
      projectName
    }
  }
`;
